import { gspx } from '@rsos/capstone';

export const trackClickCallFromQueue = (
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  serviceType,
  classOfServices,
  callStatus,
) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: 'Click on Call From Queue',
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    isSXMCrashed: isConnectedCar,
    payloadID,
    requestID,
    portalType,
    serviceType,
    classOfServices,
    callStatus: callStatus || '',
  });
};

export const trackClickCall = (
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  serviceType,
  classOfServices,
  callStatus,
) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: 'Calls Clicked On',
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    isSXMCrashed: isConnectedCar,
    payloadID,
    requestID,
    portalType,
    serviceType,
    classOfServices,
    callStatus: callStatus || '',
  });
};

export const trackRemoveCall = (
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  callStatus,
) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: 'Removed a number',
    Category: 'Google Map',
    'Launched date': new Date(),
    isSXMCrashed: isConnectedCar,
    payloadID,
    requestID,
    portalType,
    callStatus: callStatus || '',
  });
};

export const trackTT911Request = (irpVersion, payloadID, requestID) => {
  gspx.trackCustomEvent('Data CallQueueList', {
    irpVersion,
    name: 'Text-to-911 added to queue',
    Category: 'Jurisdiction View',
    'Launched date': new Date(),
    payloadID,
    requestID,
  });
};
